import { Box, Grid2, Typography } from '@mui/material'
import goldHand from 'images/hand_gold.png'
import silverIcon from 'images/silver-with-shadow.png'
import useStyles from './styles'

interface Props {
  productName?: string
}

// Product-aware empty state. Previously hardcoded "Buy gold to start" + the gold
// hand, which is wrong on the Silver product page. Now the copy uses the product
// name. There is no dedicated silver "hand" asset, so Silver falls back to the
// silver product image while Gold keeps its hand (no regression to the gold page);
// swap in a silver hand here if design provides one.
export default function NoPerformance({
  productName
}: Readonly<Props>): JSX.Element {
  const { classes } = useStyles()
  const isSilver = productName?.toLowerCase() === 'silver'
  const label = productName ? productName.toLowerCase() : 'gold'

  return (
    <Grid2 size={{ xs: 12 }}>
      <Box className={classes.wrapper}>
        <Typography variant='h4' className={classes.noPerformance}>
          No performance
        </Typography>
        <Typography variant='h6' className={classes.buyGold}>
          Buy {label} to start
        </Typography>
        <img
          src={isSilver ? silverIcon : goldHand}
          alt={`buy ${label} to start`}
          width={100}
        />
      </Box>
    </Grid2>
  )
}
